import { useController } from 'react-hook-form';

import CardCheck, { ICardCheck } from '../../card-check/card-check';
import { UseControllerProps } from './forms-types';

interface IControlledCardCheckboxProps {
  cardCheckboxProps: ICardCheck;
  controllerProps: UseControllerProps;
}

const ControlledCardCheckbox: React.FC<IControlledCardCheckboxProps> = ({
  cardCheckboxProps: { children, ...props },
  controllerProps,
}) => {
  const {
    field: { ref, ...fieldProps },
  } = useController({
    ...controllerProps,
  });
  return (
    <CardCheck {...props} {...fieldProps} inputRef={ref}>
      {children}
    </CardCheck>
  );
};

export default ControlledCardCheckbox;
